module.exports = __webpack_public_path__ + "static/img/3.728d5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad-server/3.png
// module id = 8PW6
// module chunks = 1